/**
 * @generated SignedSource<<f151566981b27e579bd84dae91b356da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShirtIcon_game$data = {
  readonly viewerTeam: {
    readonly color: string;
  } | null;
  readonly viewerIsAGoaliePlayer: boolean;
  readonly " $fragmentType": "ShirtIcon_game";
};
export type ShirtIcon_game$key = {
  readonly " $data"?: ShirtIcon_game$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShirtIcon_game">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShirtIcon_game",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GameWiewerTeam",
      "kind": "LinkedField",
      "name": "viewerTeam",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsAGoaliePlayer",
      "storageKey": null
    }
  ],
  "type": "Game",
  "abstractKey": null
};

(node as any).hash = "694cf0d2a3f16177d801cb34f99f55fd";

export default node;
